module.exports = __webpack_public_path__ + "static/media/arrow-alt-right.50c70139.svg";